import { createSlice } from "@reduxjs/toolkit";

const headerTitleSlice = createSlice({
  name: "headerTitle",

  initialState: {
    headerTitle: "",
    breadcrumbItems: [],
    isDetailPage: false,
  },

  reducers: {
    setPageTitle: (state, action) => {
      const { payload } = action;
      state.headerTitle = payload;
    },
    setPageType: (state, action) => {
      const { payload } = action;
      state.isDetailPage = payload;
    },
    setBreadcrumbItems: (state, action) => {
      const { payload } = action;
      state.breadcrumbItems = payload;
    },
  },
});

export const {
  actions: { setPageTitle, setPageType, setBreadcrumbItems },
  reducer: headerReducer,
} = headerTitleSlice;
